import { createSlice } from "@reduxjs/toolkit";
import { getDonateDetails } from "./donate.api";

const donateDetailsSlice = createSlice({
  name: "donateDetails",
  initialState: {
    donateDetails: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },

  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDonateDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDonateDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.donateDetails = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getDonateDetails.rejected, (state, action) => {
      state.loading = false;
    });

    // builder.addCase(deleteCountry.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // });
    // builder.addCase(deleteCountry.fulfilled, (state, action) => {
    //   const deletedId = action.payload.data._id;

    //   if (state.country.data) {
    //     state.country.data = state.country.data.filter((country) => {
    //       return country._id !== deletedId;
    //     });
    //     state.loading = false;
    //   } else {
    //     console.error(
    //       "state.country.data is not an array:",
    //       state.country.data
    //     );
    //   }
    //   state.loading = false;
    // });
    // builder.addCase(deleteCountry.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // });

    // builder.addCase(undoDeleteCountry.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // });
    // builder.addCase(undoDeleteCountry.fulfilled, (state, action) => {
    //   const undodeletedId = action.payload.data._id;

    //   if (state.country.data) {
    //     state.country.data = state.country.data.filter((country) => {
    //       return country._id !== undodeletedId;
    //     });
    //     state.loading = false;
    //   } else {
    //     console.error(
    //       "state.country.data is not an array:",
    //       state.country.data
    //     );
    //   }
    //   state.loading = false;
    // });
    // builder.addCase(undoDeleteCountry.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // });
  },
});

export const { resetState } = donateDetailsSlice.actions;
export default donateDetailsSlice.reducer;
